/**
 * Derives Body Mass Index from a weight (kg) and the user's profile height (cm).
 *
 * BMI is never stored — it's computed on demand from the latest weight plus the
 * profile height (see the plan). Pure and UI-free so it runs under the app's
 * `test:unit` project and can feed both the Profile summary and each trend point.
 */
export class BmiCalculator {
  /**
   * @returns BMI rounded to one decimal, or `null` when weight or height is
   * missing or non-positive (shown as `N/A` with a "fill these in" hint).
   */
  static compute(
    weightKg?: number | null,
    heightCm?: number | null,
  ): number | null {
    if (weightKg == null || heightCm == null) return null;
    if (weightKg <= 0 || heightCm <= 0) return null;

    const heightM = heightCm / 100;
    const bmi = weightKg / (heightM * heightM);
    return Math.round(bmi * 10) / 10;
  }
}
